export default __webpack_public_path__ + "static/media/858_3.bf6bdcdd.jpg";